module.exports = __webpack_public_path__ + "img/2-3.6a198da8.svg";